<template>
   <v-card class="rounded-card card-shadow mt-3">
    <v-card-text>
      <v-row dense>
        <v-col cols="12" sm="11">
          <p class="mb-1">
            <span class="title font-weight-bold text--primary">
              Mensagens personalizadas
            </span>
          </p>
          <p class="mb-1">
            <span class="font-weight text--secondary">
              Mensagens personalizadas pelos compradores que serão enviadas ao fornecedor
            </span>
          </p>
        </v-col>
        <v-col cols="12" sm="1" class="d-flex justify-end">
          <v-card-actions>
            <v-btn icon @click="expand">
              <v-icon>{{ icon }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
      <div class="mt-3" v-if="show">
        <px-mensagens-personalizadas-list
          hide-header
          :messages="compra.mensagensPersonalizadas"
          :show-actions="false"/>
      </div>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    compra: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
    };
  },
  computed: {
    icon() {
      return this.show ? 'mdi-chevron-up' : 'mdi-chevron-down';
    },
  },
  methods: {
    expand() {
      this.show = !this.show;
    },
  },
};
</script>
